/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L7_Meta_DescriptionInputs */

const es_l7_meta_description = /** @type {(inputs: L7_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alquila tu barco de lista séptima hasta 3 meses al año con Zarpar. Gestora autorizada: papeleo, seguros e inspección. Comisión 15% + IVA solo al alquilar.`)
};

const gl_l7_meta_description = /** @type {(inputs: L7_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aluga o teu barco de lista sétima ata 3 meses ao ano con Zarpar. Xestora autorizada: papeleo, seguros e inspección. Comisión 15% + IVE só ao alugar.`)
};

const en_l7_meta_description = /** @type {(inputs: L7_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rent out your List 7 boat for up to 3 months a year with Zarpar. Authorised manager: paperwork, insurance and inspection. 15% + VAT only when you rent out.`)
};

/**
* | output |
* | --- |
* | "Rent out your List 7 boat for up to 3 months a year with Zarpar. Authorised manager: paperwork, insurance and inspection. 15% + VAT only when you rent out." |
*
* @param {L7_Meta_DescriptionInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l7_meta_description = /** @type {((inputs?: L7_Meta_DescriptionInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L7_Meta_DescriptionInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l7_meta_description(inputs)
	if (locale === "en") return en_l7_meta_description(inputs)
	return es_l7_meta_description(inputs)
});